import { render, staticRenderFns } from "./AuditTrail.vue?vue&type=template&id=2b78a75a&scoped=true"
import script from "./AuditTrail.vue?vue&type=script&lang=js"
export * from "./AuditTrail.vue?vue&type=script&lang=js"
import style0 from "./AuditTrail.vue?vue&type=style&index=0&id=2b78a75a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78a75a",
  null
  
)

export default component.exports